import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { slug } from "@/lib/constants";
import { SectionHead } from "./MetricTable";

const INITIAL_SIZE = { width: 320, height: 224 };
const MARGIN = { left: 8, right: 16 };
const AXIS_LINE = { stroke: "#334155" };
const X_TICK = { fontSize: 11, fill: "#94a3b8" };
const Y_TICK = { fontSize: 11, fill: "#cbd5e1" };
const CURSOR = { fill: "rgba(99,102,241,0.12)" };
const TOOLTIP_STYLE = { background: "#0f172a", border: "1px solid #334155", borderRadius: 8, color: "#f1f5f9" };
const TOOLTIP_LABEL = { color: "#f1f5f9" };
const TOOLTIP_ITEM = { color: "#a5b4fc" };
const BAR_RADIUS = [0, 4, 4, 0];

export const LossChart = ({ data, agingCount }) => (
  <section data-testid="loss-chart-section" className="rounded-2xl border border-slate-800 bg-slate-900 p-4">
    <SectionHead title="Loss reasons" sub="Lost leads in the current filter" />
    <div className="h-56 w-full">
      <ResponsiveContainer width="100%" height="100%" initialDimension={INITIAL_SIZE}>
        <BarChart data={data} layout="vertical" margin={MARGIN}>
          <CartesianGrid horizontal={false} stroke="#1e293b" />
          <XAxis type="number" allowDecimals={false} tick={X_TICK} axisLine={AXIS_LINE} tickLine={AXIS_LINE} />
          <YAxis type="category" dataKey="reason" width={100} tick={Y_TICK} axisLine={AXIS_LINE} tickLine={AXIS_LINE} />
          <Tooltip cursor={CURSOR} contentStyle={TOOLTIP_STYLE} labelStyle={TOOLTIP_LABEL} itemStyle={TOOLTIP_ITEM} />
          <Bar dataKey="count" fill="#818cf8" radius={BAR_RADIUS} barSize={14} isAnimationActive={false} />
        </BarChart>
      </ResponsiveContainer>
    </div>
    <ul className="mt-2 grid grid-cols-2 gap-x-4 gap-y-1 text-xs sm:grid-cols-3">
      {data.map((d) => (
        <li key={d.reason} className="flex justify-between">
          <span className="text-slate-400">{d.reason}</span>
          <span data-testid={`loss-count-${slug(d.reason)}`} className="font-mono font-semibold">{d.count}</span>
        </li>
      ))}
    </ul>
    <p className="mt-3 border-t border-slate-800/70 pt-2 text-xs text-slate-400">
      Follow-Up Aging count: <span data-testid="closer-aging-count" className={`font-mono font-semibold ${agingCount > 0 ? "text-red-400" : "text-slate-50"}`}>{agingCount}</span>
    </p>
  </section>
);
